import { nl2br } from './get-merge-tag-mapping-with-values';

const prepareSearchString = (keys) =>
  keys
    .map((key) => {
      const regex =
        `${key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}` +
        "(?:(((\\s{0,})(&nbsp;(\\s){0,})*)([\\|])((\\s{0,})(&nbsp;(\\s){0,})*)(['])(.*?)([']))?)";

      const isKeyAlreadyHasOpeningAndClosingBraces = /^{{.*}}$/.test(key);

      if (isKeyAlreadyHasOpeningAndClosingBraces) {
        return regex;
      }

      return `{{${regex}}}`;
    })
    .join('|');

const prepareSearchRegex = (keys) => {
  const searchString = prepareSearchString(keys);
  return new RegExp(searchString, 'igs');
};

const extractMergeTagFromMergeTagFallbackTextString = (
  text: string,
): string => {
  const match = text.replace(/&nbsp;/g, '').match(/\{\{(.*?)\|/);
  return match ? `{{${match[1].trim()}}}` : '';
};

const capitalizeNames = (name: string, matched: string) => {
  let attributeValue: string = name;
  if (matched === '{{first name}}' || matched === '{{last name}}') {
    attributeValue = name.charAt(0).toUpperCase() + name.slice(1);
  }
  return attributeValue;
};

export const replaceAttributesWithValues = (
  content: string,
  attributesMappingForRegex: Record<string, string>,
  attributesMappingWithValues: Record<string, string>,
  previewFor: 'subject' | 'body',
): string => {
  const searchKeys = Object.keys(attributesMappingForRegex).map((key) =>
    key.toLowerCase(),
  );

  const regex = prepareSearchRegex(searchKeys);

  return content?.replace(regex, (matchedKey) => {
    const matched = matchedKey.toLowerCase();

    if (previewFor === 'subject' && matched === `{{sendersignature}}`) {
      return matchedKey;
    }

    const extractedMergeTag = matched.includes('|')
      ? extractMergeTagFromMergeTagFallbackTextString(matched)
      : ''; // extract merge tag if match includes fallback text

    // check if match has fallback text
    if (matched.includes('|')) {
      // Check if value exists for matched merge tag
      if (attributesMappingWithValues[extractedMergeTag]?.length > 0) {
        // Return value of attribute
        return capitalizeNames(
          attributesMappingWithValues[extractedMergeTag],
          extractedMergeTag,
        );
      }

      const mergeTag = extractedMergeTag.replace(/[{}]/g, '').toLowerCase();

      // Return Fallback text if value not found
      const reg = new RegExp(
        `{{\\s*${mergeTag}\\s*\\|\\s*'([\\s\\S]*?)'\\s*}}`,
        'i',
      );
      const fallbackText = matchedKey.match(reg)?.[1] || '';

      const isValidHTML = /<\/?[a-z][\s\S]*>/i.test(fallbackText);
      return isValidHTML ? fallbackText : nl2br(fallbackText);
    }

    // Return value of attribute if
    // return capitalizeNames(attributesMappingWithValues[matched], matched) || '';
    return attributesMappingWithValues[matched] || '';
  });
};
